import { render, staticRenderFns } from "./SiteNavDesktopTopItem.vue?vue&type=template&id=014a51bf&scoped=true&lang=pug"
import script from "./SiteNavDesktopTopItem.vue?vue&type=script&lang=js"
export * from "./SiteNavDesktopTopItem.vue?vue&type=script&lang=js"
import style0 from "./SiteNavDesktopTopItem.vue?vue&type=style&index=0&id=014a51bf&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a51bf",
  null
  
)

export default component.exports